import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { signInWithRedirect } from "aws-amplify/auth";
import { configureAmplify } from "../../helpers/amplifyConfig";
import { AuthContext } from "../../context/AuthContext";

const SLUG_REGEX = /^[a-z0-9][a-z0-9-]{1,62}$/;

export function SSOStart() {
  const { providerName } = useParams<{ providerName: string }>();
  const { authenticated, user, validating } = useContext(AuthContext);
  const navigate = useNavigate();

  const isValidSlug = !!providerName && SLUG_REGEX.test(providerName);

  useEffect(() => {
    if (!isValidSlug) return;
    if (validating) return;
    if (authenticated && user?.customerId) {
      navigate(`/customers/${user.customerId}`, { replace: true });
      return;
    }

    const start = async () => {
      await configureAmplify(providerName);
      await signInWithRedirect({ provider: { custom: providerName } });
    };
    void start();
  }, [authenticated, isValidSlug, navigate, providerName, user?.customerId, validating]);

  if (!isValidSlug) {
    return (
      <Box className="w-1/2 m-auto pt-8" textAlign="center">
        <Typography variant="h5" gutterBottom>
          This sign-in link is invalid
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Contact your administrator.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      className="w-full pt-8"
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={2}
    >
      <CircularProgress />
      <Typography variant="body1">Signing you in…</Typography>
    </Box>
  );
}

export default SSOStart;
